export default __webpack_public_path__ + "static/media/8ac75167-e862-4750-a3e1-9e18a8a07195.990e0480.ttf";